import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import { closeSliderCart } from '../../sections/slider-cart';
import { closeMobileFilterNav } from '../../components/mobile-filter-nav';
import { initAccordion } from '../../components/accordion';

const adjustBottomElement = ($subnav) => {
  const calculated_subnav_height = $subnav.find('.mobile-subnav__parent').outerHeight(true) + $subnav.find('.mobile-nav__level-2').outerHeight(true) + $subnav.find('.mobile-subnav__footer-image').outerHeight(true);

  $('[data-mobile-bottom]').css({
    'top': `${calculated_subnav_height + $('[data-mobile-top]').outerHeight(true)}px`,
    'height': `${$('[data-mobile-bottom] .mobile-nav-bottom__container').outerHeight(true)}px`,
  });
};

const openMobileSubNav = ($item) => {
  const handle = $item.data('handle');
  const $subnav = $(`.mobile-subnav[data-parent="${handle}"]`);

  if ($subnav.length) {
    adjustBottomElement($subnav);
    $subnav.addClass('opened');
    $('[data-mobile-nav]').addClass('level-2-opened');
    // $('[data-mobile-nav]').animate({ scrollTop: 0 }, 'fast');
    $('[data-mobile-nav]').scrollTop(0);

    document.querySelectorAll('.mobile-nav__level-1 [data-has-children]').forEach((item) => {
      item.setAttribute('role', 'menuitem');
      item.setAttribute('aria-expanded', 'false');
    });

    $item.attr('aria-expanded', 'true');
    $subnav.attr('aria-live', 'polite');
  }
};

const closeMobileSubNav = ($item) => {
  $('[data-mobile-bottom]').removeAttr('style');
  $item.addClass('closing');
  $('[data-mobile-nav]').removeClass('level-2-opened');

  window.setTimeout(() => {
    $item.removeClass('closing').removeClass('opened');
    $('[data-mobile-nav]').animate({ scrollTop: 0 }, 'fast');
    $item.attr('aria-expanded', 'false');
  }, 300);
};

const openMobileNav = (search_focus) => {
  if (window.theme.breakpoints.current !== 'mobile') {
    return;
  }

  // Fix a iOS Safari bug to reset the scrollTop
  $('[data-mobile-nav]').css('position', 'absolute');
  $('[data-mobile-nav]').addClass('visible');

  window.setTimeout(() => {
    $('[data-mobile-nav]').removeAttr('style');
    $('[data-mobile-nav]').scrollTop(0);
    $('html').addClass('mobile-nav-opened');
    disableBodyScroll($('[data-mobile-nav]')[0]);

    const mobileNav = document.querySelector('[data-mobile-nav]');
    mobileNav.setAttribute('aria-hidden', 'false');
    mobileNav.focus();
  
    if (search_focus) {
      $('#searchMobile').trigger('focus');
    }
  }, 50);
};

const closeMobileNav = (force = false) => {
  if (window.theme.breakpoints.current !== 'mobile' && !force) {
    return;
  }

  $('html').removeClass('mobile-nav-opened');
  enableBodyScroll($('[data-mobile-nav]')[0]);

  const $opened_subnav = $('.opened[data-mobile-subnav]');
  if ($opened_subnav.length) {
    closeMobileSubNav($opened_subnav);
  }

  document.querySelector('[data-mobile-nav]').setAttribute('aria-hidden', 'true');

  if (document.querySelector('[data-open-mobile-nav]')) {
    document.querySelector('[data-open-mobile-nav]').focus();
  }

  window.setTimeout(() => {
    $('[data-mobile-nav]').removeClass('visible');
  }, 300);
};

/*
const injectFeaturedItems = () => {
  if (!$('[data-mobile-nav]').data('show-featured')) {
    $('[data-mobile-bottom]').remove();
    return;
  }

  let inject_html = '';
  _.each($('[data-main-nav] [data-mega-featured-item]'), (item) => {
    inject_html += `
      <div class="featured-item" onClick="window.location.href='${$(item).find('a').attr('href')}';">
        ${$(item).find('noscript').text().replace('2048x2048', '280x280')}
        ${$(item).find('a')[0].outerHTML}
      </div>
    `;
  });
  $('[data-mobile-bottom]').append(`<li class="featured-items">${inject_html}</li>`);
};
*/

const initMobileNav = () => {
  // injectFeaturedItems();

  $(document).on('click', '[data-mobile-nav-open]', () => {
    const search_focus = false;
    // if ($item.hasClass('mobile-option--search')) {
    //   search_focus = true;
    // }

    ($('html').hasClass('mobile-nav-opened')) ? closeMobileNav() : openMobileNav(search_focus);
  });

  // [ADA]
  if ($('[data-mobile-bottom-accordion]').length) {
    initAccordion('[data-mobile-bottom-accordion]');

    document.querySelectorAll('[data-mobile-bottom-accordion]').forEach((accordion) => {
      accordion.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          accordion.click();
        }
      });
    });
  }

  // [ADA]
  document.querySelector('[data-mobile-nav-open]').addEventListener('keypress', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.target.click();
    }
  });

  $(document).on('click touchend', '[data-full-overlay]', (e) => {
    e.stopPropagation();
    e.preventDefault();

    closeMobileNav();
    closeSliderCart();
    closeMobileFilterNav();
  });

  $(document).on('click', '.mobile-nav__level-1 [data-has-children]', (e) => {
    const $item = $(e.currentTarget);

    openMobileSubNav($item);
  });

  // Close mobile subnav
  $(document).on('click', '.opened[data-mobile-subnav] .mobile-subnav__parent', (e) => {
    const $item = $(e.currentTarget);

    closeMobileSubNav($item.parent());
  });

  $(window).on('breakpointHasChanged', (e, current_breakpoint) => {
    if (current_breakpoint !== 'mobile' && $('html').hasClass('mobile-nav-opened')) {
      closeMobileNav(true);
    }
  });
};

export { initMobileNav, closeMobileNav };
